import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Chip from "@mui/material/Chip";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

import api from "services/api";
import { requireAuth, getCurrentUser, logoutUser } from "actions/AuthAction";

function ProfileOverview() {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [form, setForm] = useState({ nama: "", email: "", no_hp: "" });
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    const u = requireAuth(navigate);
    if (!u) return;
    setUser(u);
    setForm({ nama: u.nama || "", email: u.email || "", no_hp: u.no_hp || "" });

    api.get("auth/me").then((res) => {
      const data = res.data?.data;
      if (data) {
        setUser({ ...u, ...data });
        setForm({ nama: data.nama || "", email: data.email || "", no_hp: data.no_hp || "" });
      }
    });
  }, [navigate]);

  const handleSave = async () => {
    setSaving(true);
    try {
      const res = await api.put("users/profile", form);
      const updated = res.data?.data;
      const stored = getCurrentUser();
      localStorage.setItem("user", JSON.stringify({ ...stored, ...updated }));
      alert("Profil berhasil diperbarui");
      window.location.reload();
    } catch (err) {
      alert(err.response?.data?.message || "Gagal memperbarui profil");
    } finally {
      setSaving(false);
    }
  };

  if (!user) return null;

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={3}>
        <Grid container spacing={3} justifyContent="center">
          <Grid item xs={12} lg={8}>
            <Card>
              <MDBox p={3}>
                <MDBox display="flex" justifyContent="space-between" alignItems="center" mb={3}>
                  <MDBox>
                    <MDTypography variant="h5">{user.nama}</MDTypography>
                    <Chip label={user.role} color="info" size="small" sx={{ mt: 1 }} />
                  </MDBox>
                  <MDTypography variant="button" color="text">
                    @{user.username}
                  </MDTypography>
                </MDBox>

                {["nama", "email", "no_hp"].map((field) => (
                  <MDBox mb={2} key={field}>
                    <MDInput
                      label={field === "no_hp" ? "No. HP / WhatsApp" : field.charAt(0).toUpperCase() + field.slice(1)}
                      fullWidth
                      value={form[field]}
                      onChange={(e) => setForm({ ...form, [field]: e.target.value })}
                    />
                  </MDBox>
                ))}

                <MDBox display="flex" gap={1} mt={3}>
                  <MDButton variant="gradient" color="info" onClick={handleSave} disabled={saving}>
                    {saving ? "Menyimpan..." : "Simpan Profil"}
                  </MDButton>
                  <MDButton variant="outlined" color="error" onClick={() => logoutUser(navigate)}>
                    Keluar
                  </MDButton>
                </MDBox>
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default ProfileOverview;
